import React from 'react';
export const WhyMedicineFails = () => {
  const rows = [{
    give: 'Birth control pill to regulate your cycle',
    need: 'Understanding WHY your cycle is dysregulated'
  }, {
    give: 'Antidepressants for mood',
    need: 'Knowing that your LIVER and GUT control your serotonin'
  }, {
    give: 'Sleeping pills',
    need: 'Repairing your circadian rhythm and melatonin'
  }, {
    give: "Everything is normal, it's just stress",
    need: 'A real protocol that addresses the ROOT cause'
  }];
  return <section className="w-full bg-white py-8 md:py-12 px-4 md:px-6" data-id="element-270">
      <div className="max-w-[780px] mx-auto" data-id="element-271">
        <h2 className="font-playfair text-[28px] md:text-[38px] text-primary text-center mb-6" data-id="element-272">
          Why Conventional Medicine Is Failing You
        </h2>

        <div className="rounded-[16px] border border-accent overflow-hidden" data-id="element-273">
          {/* Headers */}
          <div className="grid grid-cols-2" data-id="element-274">
            <div className="bg-errorBg text-error font-lato font-bold text-[16px] text-center p-4" data-id="element-275">
              What They Give You
            </div>
            <div className="bg-[#F0EBF8] text-primary font-lato font-bold text-[16px] text-center p-4" data-id="element-276">
              What You Actually Need
            </div>
          </div>

          {/* Rows */}
          <div className="flex flex-col" data-id="element-277">
            {rows.map((row, index) => <div key={index} className={`grid grid-cols-2 border-t border-accent ${index % 2 === 0 ? 'bg-white' : 'bg-light'}`} data-id="element-278">
                <div className="font-lato text-[15px] text-body p-4 md:px-5 border-r border-accent flex items-center" data-id="element-279">
                  {row.give}
                </div>
                <div className="font-lato text-[15px] text-body p-4 md:px-5 flex items-center" data-id="element-280">
                  {row.need}
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
};